import { ChargeDetailConstant } from "../ChargeDetailMaintenance/ChargeDetailConstant";

export const AdhocHoldOfCntrConstant = {
    CATEGORY: "Counter Charge",
    TITLE: "Adhoc Hold of Container",
    SEARCH_CRITERIA: "Search Criteria",
    CONSORTIUM_CODE: "Consortium Code",
    VESSEL_CODE: "Vessel Code",
    VOYAGE_CODE: "Voyage Code",
    CONTAINER_NO: 'Container No.',
    BILL_OF_LADING: 'Bill Of Lading',
    SHIPPING_BILL: 'Shipping Bill',
    REASON_CODE: 'Reason Code',
    CO_VSL_VOY: ChargeDetailConstant.Charge.CO_VSL_VOY,
}
